<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>
    <template #content>
      <article class="blog-content" lang="de">
        <section class="intro">
          <p>
            Mit <strong>Google Maps 360</strong> meinen Nutzer meist die
            <strong>360°-Fotos</strong> auf Ihrer Unternehmensfiche — technisch
            powered by <strong>Google Street View</strong>, sichtbar in Maps, der
            Suche und der <strong>Street View App</strong>.
          </p>
          <p>
            Dieser Leitfaden zeigt, wo der Inhalt erscheint, wie die Street View
            App funktioniert und wann Travvir mit
            <a href="/blog/de/google-street-view">Direktveröffentlichung</a> die
            bessere Wahl ist.
            <strong>Aktuell</strong> veröffentlicht Travvir über sein eigenes
            Street-View-Publisher-Konto, nicht über Ihr Google-Konto.
          </p>
        </section>

        <section>
          <h2>Wo Maps-360-Inhalte erscheinen</h2>
          <ul>
            <li>Google-Suche: Business-Profil mit 360°-Ansicht.</li>
            <li>Google Maps: Fotogalerie und Karten-Pins.</li>
            <li>Street View App: Vollbild-Panoramen auf iOS und Android.</li>
          </ul>
        </section>

        <section>
          <h2>Street View App (kostenlos)</h2>
          <ol>
            <li>App installieren, mit Google-Business-Konto anmelden.</li>
            <li>Kamera-Icon → geführte Aufnahme für eine Sphere.</li>
            <li>Standort prüfen und auf Maps veröffentlichen.</li>
            <li>Google-Prüfung: meist 24–72 Stunden.</li>
          </ol>
        </section>

        <section>
          <h2>Travvir (Mehrere Räume)</h2>
          <p>
            Tour am Smartphone bauen, für die Website einbetten, dann über
            Teilen → Google Street View auf Maps veröffentlichen. Travvir nutzt
            dafür sein <strong>Publisher-Konto bei Google Street View</strong> —
            kein eigenes Google-Login in der App. Details:
            <a href="/blog/de/google-street-view">Google Street View mit Travvir</a>.
          </p>
        </section>

        <section>
          <h2>Vergleich</h2>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Street View App</th>
                <th>Travvir</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mehrere Räume</td>
                <td>Manuell pro Szene</td>
                <td>Verknüpfte Tour</td>
              </tr>
              <tr>
                <td>Website-Embed</td>
                <td>Begrenzt</td>
                <td>Hotspots &amp; Branding</td>
              </tr>
              <tr>
                <td>Maps-Veröffentlichung</td>
                <td>Ihr Google-Konto in der Street View App</td>
                <td>Teilen → Google Street View (über Travvirs Konto)</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>FAQ</h2>
          <p>
            <strong>Wie lange dauert die Freigabe?</strong> In der Regel 24–72
            Stunden nach Google-Prüfung.
          </p>
          <p>
            <strong>Travvir:</strong> Kein privates Google-Konto nötig — Upload
            über Travvirs Publisher-Konto. <strong>Street View App:</strong> Mit
            einem Konto anmelden, das das Business-Profil der Adresse verwaltet.
          </p>
        </section>

        <section>
          <h2>Weiterlesen</h2>
          <ul>
            <li>
              <a href="/blog/de/google-street-view"
                >Auf Google Street View veröffentlichen</a
              >
            </li>
            <li>
              <a href="/blog/de/google-business-virtual-tour"
                >Google Business Virtual Tour</a
              >
            </li>
          </ul>
        </section>

        <RelatedPosts
          :currentSlug="postData.slug"
          :currentCategories="postData.categories"
        />
      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";
const postData = blogPostsData.find((p) => p.slug === "google-maps-360");

useBlogSeo({
  title: "Google Maps 360 und Street View App: Business-Leitfaden [2026] | Travvir",
  description:
    "Google Maps 360 für Unternehmen: Street View App nutzen oder 360°-Tour mit Travvir auf Google Maps veröffentlichen.",
  keywords:
    "google maps 360, street view app, google street view, 360 google maps unternehmen",
  slug: "google-maps-360",
  image: postData?.image,
  postData,
  lang: "de",
});
</script>
